<script>
    import { Bar } from "vue-chartjs";
    import numerial from 'numeral';
    export default {
        extends: Bar,
        props: {
            month: {
                type: Number,
                default: new Date().getMonth() + 1
            }
        },
        data() {
            return {
                query: {
                    Limit: 5,
                    Month: this.month
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    hover: {
                        animationDuration: 0
                    },
                    animation: {
                        duration: 1,
                        onComplete() {
                            var chartInstance = this.chart, ctx = chartInstance.ctx;
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';
                            this.data.datasets.forEach((dataset, i) => {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach((bar, index) => {
                                    var data = numerial(dataset.data[index]).format('$0,0.[00]');
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                });
                            });
                        }
                    }
                }
            }
        },
        mounted() {
            this.toList();
        },
        methods: {
            toList(){
                let loading = this.$loading.show({
                    container: this.$refs.load100,
                });
                this.$api().post('top-sale-per-month-chart', this.query).then(res => {
                    if(this.$isValid(res)){
                        let config = {
                            labels: res.data.Json.Labels,
                            datasets: [
                                {
                                    label: this.$t("statistic_top_sale_in_month"),
                                    backgroundColor: "#e60000",
                                    data: res.data.Json.Amount
                                }
                            ]
                        }
                        this.renderChart(config, this.options);
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
        watch: {
            month(value){
                this.query.Month = value;
                this.toList();
            }
        }
    }
</script>